
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import NodeFormMixin from './NodeFormMixin';
import TNodeDialogForm from './NodeDialogForm.vue';

@Component({
  name: 'ActionForm',
  components: {
    TNodeDialogForm,
  },
})
export default class ActionForm extends NodeFormMixin {
  @Prop({
    required: true,
  })
  schema: any;

  update(value) {
    this.data = {
      ...this.data,
      action: value,
    };
  }
}
